import React, { FunctionComponent, useMemo } from 'react';

import { ListBox } from '@yandex-360/orb-components/dist/components/ListBox';
import { ListBoxItem, ListBoxItemProps } from '@yandex-360/orb-components/dist/components/ListBoxItem';
import cn from 'classnames';
import { range } from 'lodash';
import { useSelector } from 'react-redux';

import { i18nMonthsNominative } from '../../../../../../shared/helpers/i18n';
import { DATE_RANGE_TYPE } from '../../../../constants';
import { getDatesBounds } from '../../../../helpers/get-dates-bounds';
import { useIsMobileOneColLayout } from '../../../../hooks';
import { selectDateRangeType, selectFilterSelectedMonth } from '../../../../selectors';
import styles from './styles.css';

type MonthsListBoxProps = {
    onMonthSelected: (item: ListBoxItemProps<Date>) => void;
};

const CONFERENCE_HISTORY_SIZE_MONTH = 4;
const monthsOffsets = range(CONFERENCE_HISTORY_SIZE_MONTH).reverse();
export const MonthsListBox: FunctionComponent<MonthsListBoxProps> = ({ onMonthSelected }) => {
    const datesBounds = useMemo(() => getDatesBounds(), []);
    const dateRangeType = useSelector(selectDateRangeType);
    const selectedMonth = useSelector(selectFilterSelectedMonth);
    const isOneColLayout = useIsMobileOneColLayout();
    const listBoxItems = useMemo(() => {
        return monthsOffsets.map((monthOffset) => {
            const monthDate = new Date(datesBounds.from);
            monthDate.setMonth(monthDate.getMonth() + monthOffset);
            monthDate.setDate(1);
            return (
                <ListBoxItem
                    label={i18nMonthsNominative()[monthDate.getMonth()]}
                    itemKey={monthDate}
                    key={monthOffset}
                    isSelected={
                        dateRangeType === DATE_RANGE_TYPE.SPECIFIC_MONTH && Number(selectedMonth) === Number(monthDate)
                    }
                    onItemSelect={onMonthSelected}
                />
            );
        });
    }, [dateRangeType, datesBounds.from, onMonthSelected, selectedMonth]);
    return <ListBox className={cn({ [styles.oneColLayout]: isOneColLayout })}>{listBoxItems}</ListBox>;
};
